/* ============================================================
   FIXES RAKK.FR - custom.js
   ============================================================ */

(function () {
  'use strict';

  var DESKTOP_BREAKPOINT = 1041;

  function isDesktop() {
    return window.innerWidth >= DESKTOP_BREAKPOINT;
  }

  function initCarouselBeside() {
    var galleries = document.querySelectorAll('.gallery.gallery--layout-carousel-beside');

    galleries.forEach(function (gallery) {
      var mainImage   = gallery.querySelector('.main-image');
      var carousel    = gallery.querySelector('.cc-carousel');
      var scrollOuter = gallery.querySelector('.cc-carousel__scroll-outer');
      var prevBtn     = gallery.querySelector('.cc-thumb-btn--prev');
      var nextBtn     = gallery.querySelector('.cc-thumb-btn--next');

      if (!carousel || !scrollOuter) return;

      // Attacher les listeners une seule fois
      if (!carousel._rakkInit) {
        carousel._rakkInit = true;

        if (prevBtn) {
          prevBtn.addEventListener('click', function () {
            scrollOuter.scrollBy({ top: -88, behavior: 'smooth' });
          });
        }
        if (nextBtn) {
          nextBtn.addEventListener('click', function () {
            scrollOuter.scrollBy({ top: 88, behavior: 'smooth' });
          });
        }
        scrollOuter.addEventListener('scroll', function() { updateButtons(scrollOuter, prevBtn, nextBtn); });
      }

      syncHeight(gallery, mainImage, carousel, scrollOuter, prevBtn, nextBtn);
    });
  }

  function syncHeight(gallery, mainImage, carousel, scrollOuter, prevBtn, nextBtn) {
    if (isDesktop()) {
      // Desktop : appliquer la hauteur = celle de l'image principale
      var h = mainImage ? mainImage.offsetHeight : 486;
      if (h > 0) {
        carousel.style.height = h + 'px';
      }
    } else {
      // Mobile/tablette : supprimer tout style inline pour laisser le CSS natif gérer
      carousel.style.height = '';
      carousel.style.width = '';
      carousel.style.display = '';
      carousel.style.flexDirection = '';
      carousel.style.overflow = '';
    }
    updateButtons(scrollOuter, prevBtn, nextBtn);
  }

  function updateButtons(scrollOuter, prevBtn, nextBtn) {
    if (!prevBtn || !nextBtn) return;
    if (!isDesktop()) return;
    var atTop    = scrollOuter.scrollTop <= 2;
    var atBottom = scrollOuter.scrollTop + scrollOuter.clientHeight >= scrollOuter.scrollHeight - 2;
    prevBtn.disabled = atTop;
    nextBtn.disabled = atBottom;
    // Cacher les boutons si pas besoin de scroller
    var needsScroll = scrollOuter.scrollHeight > scrollOuter.clientHeight + 4;
    prevBtn.closest('.cc-carousel')?.classList.toggle('no-scroll', !needsScroll);
  }

  function onResize() {
    var galleries = document.querySelectorAll('.gallery.gallery--layout-carousel-beside');
    galleries.forEach(function(gallery) {
      var mainImage   = gallery.querySelector('.main-image');
      var carousel    = gallery.querySelector('.cc-carousel');
      var scrollOuter = gallery.querySelector('.cc-carousel__scroll-outer');
      var prevBtn     = gallery.querySelector('.cc-thumb-btn--prev');
      var nextBtn     = gallery.querySelector('.cc-thumb-btn--next');
      if (carousel && scrollOuter) {
        syncHeight(gallery, mainImage, carousel, scrollOuter, prevBtn, nextBtn);
      }
    });
  }

  // Init
  function init() {
    initCarouselBeside();
    window.addEventListener('load', initCarouselBeside);
    var resizeTimer;
    window.addEventListener('resize', function() {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(onResize, 100);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();